export enum ACHIEVEMENT_LOCK_DATE_MONTH_TYPES {
  CURRENT_MONTH = 'CURRENT_MONTH',
  PREVIOUS_MONTH = 'PREVIOUS_MONTH',
}
